
import React from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Skeleton } from '@/components/ui/skeleton';
import { App } from '@/types/App';
import { useAppStoreDetails } from '@/hooks/useAppStoreDetails';

interface AppDescriptionProps {
  app: App;
}

const AppDescription: React.FC<AppDescriptionProps> = ({ app }) => {
  const { appDetails, isLoading, error } = useAppStoreDetails(app.appStoreId || '');

  return (
    <div className="h-full flex flex-col">
      <ScrollArea className="h-full">
        <div className="px-5 pb-8">
          {/* Description Section */}
          <div className="border-b border-border/30 pb-4 mb-4">
            <h3 className="text-base font-semibold text-foreground mb-3">
              Description
            </h3>
            {isLoading ? (
              <div className="space-y-2">
                <Skeleton className="h-3 w-full" />
                <Skeleton className="h-3 w-full" />
                <Skeleton className="h-3 w-4/5" />
                <Skeleton className="h-3 w-3/5" />
              </div>
            ) : error ? (
              <p className="text-[13px] text-muted-foreground leading-[1.4]">
                Unable to load app description. Please check your connection and try again.
              </p>
            ) : (
              <p className="text-[13px] text-muted-foreground leading-[1.5] whitespace-pre-line">
                {appDetails?.description || 'No description available from App Store.'}
              </p>
            )}
          </div>
          
          {/* What's New / Version Section */}
          <div className="pb-4">
            <h3 className="text-base font-semibold text-foreground mb-2">
              What's New
            </h3>
            {isLoading ? (
              <Skeleton className="h-3 w-20" />
            ) : (
              <p className="text-[13px] text-muted-foreground">
                Version {appDetails?.version || 'N/A'}
              </p>
            )}
          </div>
        </div>
      </ScrollArea>
    </div>
  );
};

export default AppDescription;
